import { AsapAction } from './AsapAction';
import { AsapScheduler } from './AsapScheduler';
export var asapScheduler = new AsapScheduler(AsapAction);
//# sourceMappingURL=asap.js.map